import ImageForProductById from './imageForProductById';

export default ImageForProductById;